export enum LoyaltyReservoir {
  BIBLIOTECA_GENERAL = 'FIDELIDAD_Biblioteca',
  SLIDER = 'FIDELIDAD_SLIDER',
  MATERIALES_CATEGORIAS = 'FIDELIDAD_CATEGORIA_MATERIALES',
  MATERIALES_SUBCATEGORIAS = 'FIDELIDAD_SUBCATEGORIA_MATERIALES',
  MATERIALES_ITEMS = 'FIDELIDAD_MATERIALES',
  PROPUESTAS_DESTINATARIOS = 'FIDELIDAD_PROPUESTAS_DESTINATARIOS',
  PROPUESTAS = 'FIDELIDAD_PROPUESTAS',
  COMENTARIOS_DESTINATARIOS = 'FIDELIDAD_COMENTARIOS_DESTINATARIOS',
  COMENTARIOS_PROGRAMA = 'FIDELIDAD_COMENTARIOS_PROGRAMA',
  FIDELIDAD_ON_MANUAL = 'FIDELIDAD_ON_Manual',
  FIDELIDAD_ACCESOS_INTERES = 'FIDELIDAD_ACCESOS_INTERES',
}
